import { SubnodeOutlined } from '@ant-design/icons';
import { yup } from '@framework/validation';
import React from 'react';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getSimpleWidgetReference } from '../../../../expressions/references/builder/getSimpleWidgetReference';
import { CustomWarningsRule, RequiredRule } from '../../../../rules/repository';
import type { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema';
import { InputCommonTranslationSchema } from '../../translations/InputCommonTranslationSchema';
import { IRepeatControllerWidget } from './IRepeatControllerWidget';
import { RepeatControllerWidgetComponent } from './RepeatControllerWidgetComponent';
import {
  RepeatControllerConfigSchema,
  RepeatControllerWidgetConfigComponent,
} from './RepeatControllerWidgetConfigComponent';
import { RepeatControllerWidgetPreview } from './RepeatControllerWidgetPreview';

/**
 * Tipo del componente  contenitore di una lista ripetibile di Widget.
 */
export const RepeatControllerWidgetType: IWidgetType<IRepeatControllerWidget> =
  {
    type: WidgetType.RepeatController,
    mainType: WidgetMainType.Input,
    category: WidgetCategory.Advanced,
    name: 'Controllo Lista Ripetibile',
    icon: <SubnodeOutlined />,
    hasValue: true,
    getReference: getSimpleWidgetReference(Datatype.Number),
    formComponent: RepeatControllerWidgetComponent,
    createFormSchema: ({ widget }) =>
      createCommonFormSchema(
        yup.number().min(0).integer().notRequired(),
        widget,
      ),
    configComponent: RepeatControllerWidgetConfigComponent,
    configValidator: RepeatControllerConfigSchema,
    previewComponent: RepeatControllerWidgetPreview,
    translationSchema: InputCommonTranslationSchema,
    rules: [RequiredRule, CustomWarningsRule],
  };
